import React from 'react'
import parse, { Element } from 'html-react-parser'
import { type Parser, nodeParser } from './node-parsers'
import { log } from '@dustin-web/microsite-config/src/logger'
import { BasicMacroContentProvider } from './basic-macro-content-effects'
import { nodeParserOptions } from './options'

type Props = {
  content: string
  additionalMacros?: object
  additionalNodeParsers?: Parser[]
}

export const BasicMacroContent = ({
  content,
  additionalMacros = {},
  additionalNodeParsers = [],
}: Props) => {
  content = content.split('<?UMBRACO_MACRO').join('<embed')

  let htmlComponents: ReturnType<typeof parse> = ''
  try {
    htmlComponents = parse(content, {
      ...nodeParserOptions,
      replace: domnode =>
        nodeParser(domnode as Element, additionalMacros, additionalNodeParsers) ?? domnode,
    })
  } catch (err) {
    const message = 'Invalid HTML content on content page'

    // eslint-disable-next-line no-console
    console.warn(message, err)
    log.warn(message)
  }

  return <BasicMacroContentProvider>{htmlComponents}</BasicMacroContentProvider>
}
